// @ts-ignore
import AppLayout from "@/layouts/App.vue";
import DefaultLayout from "@/layouts/Default.vue";

export default {
    AppLayout,
    DefaultLayout
}